import type { ThirdPartyPlugin } from '../types';
import { promisifyLoad } from '../utils';
import type { FacebookQueue } from './types';
import { setup, load } from './script';

declare global {
  interface Window {
    /**
     * Facebook pixel queue
     * @see [fbq docs](https://www.facebook.com/business/help/402791146561655?id=1205376682832142)
     */
    fbq: FacebookQueue;
  }
}

const PIXEL_ID_PROD = '435052424603450';
const PIXEL_ID_DEV = '1907034279475357';

const config = {
  id: process.env.isProduction ? PIXEL_ID_PROD : PIXEL_ID_DEV,
};

const facebookPlugin: ThirdPartyPlugin = () => {
  setup(config);

  return {
    entry: window.fbq,
    load: promisifyLoad(load, config),
    // isInitialized: isInitialized.bind(null, config),
  };
};

export default facebookPlugin;
